<template>
  <ul v-if="visiblePaymentIcons.length" class="flex flex-wrap" :class="gapClasses[gap]">
    <li v-for="icon in visiblePaymentIcons" :key="icon.title">
      <PaymentMethodSymbol v-bind="{ outlined, size }" :variant="icon" />
    </li>
  </ul>
</template>

<script lang="ts" setup>
import type { PaymentMethodSymbolProps } from './PaymentMethodSymbol.vue'

type PaymentMethodSymbolsProps = Pick<PaymentMethodSymbolProps, 'outlined' | 'size'> & {
  filter?: string[]
  gap?: keyof typeof gapClasses
}

const gapClasses = {
  lg: 'gap-x-300 gap-y-200',
  md: 'gap-200',
  sm: 'gap-100',
  xs: 'gap-050',
} as const

const { filter = [], gap = 'md', outlined = true } = defineProps<PaymentMethodSymbolsProps>()

const visiblePaymentIcons = usePaymentIcons(filter)
</script>
